<template>
  <div class="d-flex position-relative h-100 align-items-stretch cabin-ship-view-container">
    <div 
      class="cabin-labels d-flex flex-column justify-content-between"
    >
      <div 
        v-for="pos in ['vorne', 'mittig', 'hinten']" 
        :key="pos"
        :class="pos" 
        class="d-flex flex-column justify-content-between"
      >
        <CabinLabel 
          v-for="(cabin, index) of leftCabins[pos as keyof ICabinsOfPosition]"
          :key="index"
          :cabin="cabin"
          :select="selectCabin"
          :selected="cabin.id === selectedCabinId"
        />
      </div>
    </div>
    <div 
      v-if="!!deck"
      class="ship d-flex justify-content-center" 
    >
      <ShipView
        :deck="deck"
        :cabins="matchingCabins"
        :selected-cabin-id="selectedCabinId"
      />
    </div>
    <div 
      v-else 
      class="d-flex align-items-center text-center ship-view-error"
    >
      <span>
        Leider ist ein Fehler beim Laden des Schiffsplans aufgetreten. Bitte versuchen Sie es später erneut...
      </span>
    </div>

    <div class="cabin-labels d-flex flex-column justify-content-between">
      <div 
        v-for="pos in ['vorne', 'mittig', 'hinten']"
        :key="pos"
        class="d-flex flex-column justify-content-between"
        :class="pos" 
      >
        <CabinLabel
          v-for="(cabin, index) of rightCabins[pos as keyof ICabinsOfPosition]"
          :key="index"
          :cabin="cabin"
          :select="selectCabin"
          :selected="cabin.id === selectedCabinId"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ICabinsOfPosition } from '@/components/interfaces';
import { useCabinStore } from '@/store';
import { groupBy, sortBy } from 'lodash-es';
import { mapState } from 'pinia';
import { defineComponent } from 'vue';
import CabinLabel from './CabinLabel.vue';
import ShipView from './ShipView.vue';

export default defineComponent({
  components: { ShipView, CabinLabel },

  props: {
    selectCabin: {
      type: Function,
      default: () => undefined,
    },
  },

  computed: {
    ...mapState(useCabinStore, {
      selectedCabin: store => store.cabin,
      deck: store => store.deck,
    }),
    ...mapState(useCabinStore, {
      matchingCabins: 'matchingCabins',
    }),

    leftCabins(): ICabinsOfPosition {
      if (!this.matchingCabins?.length || !this.deck) {
        return { vorne: null, mittig: null, hinten: null }
      }

      const leftCabs = sortBy(
        this.matchingCabins.filter(cabin => {
          return cabin.deck === this.deck!.id && cabin.location === 'backbord'
        }),
        ['id']
      )
      const groupedCabs = groupBy(leftCabs, 'position')

      return {
        vorne: groupedCabs.vorne,
        mittig: groupedCabs.mittig,
        hinten: groupedCabs.hinten,
      }
    },
    rightCabins(): ICabinsOfPosition {
      if (!this.matchingCabins?.length || !this.deck) {
        return { vorne: null, mittig: null, hinten: null }
      }
      const rightCabs = sortBy(
        this.matchingCabins.filter(cabin => {
          return cabin.deck === this.deck!.id && cabin.location === 'steuerbord'
        }),
        ['id']
      )
      const groupedCabs = groupBy(rightCabs, 'position')
      return {
        vorne: groupedCabs.vorne,
        mittig: groupedCabs.mittig,
        hinten: groupedCabs.hinten,
      }
    },
    selectedCabinId() {
      return this.selectedCabin?.id ?? ''
    }
  },
})
</script>

<style lang="scss" scoped>
@import '../../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.cabin-ship-view-container {
  // TODO: fix this
  // Workaround since the ship is somehow cut at the bottom since bootstrap
  padding-bottom: 50px;
}

.cabin-labels {
  width: 50px;
}

.vorne {
  flex: 2;
}

.mittig {
  flex: 3;
}

.hinten {
  flex: 2;
}

.ship {
  width: 200px;
  flex: 1;
}

.ship-view-error {
  font-size: 16px;
  color: $color-expinet-gray;
}
</style>
